/**
   * Returns the dimensions of the target container to calculate smart position against
   * @param container
   * @return {height: number, width: number}
   */
function getContainerDimensions(container) {
  return {
    height: container.innerHeight || container.offsetHeight || 0,
    width: container.innerWidth || container.offsetWidth || 0
  };
}
/**
 * Checks if a given element rectangle goes outside the given window viewport
 * @param tooltipRefObj {RefObject} target element can be a window or a ref of the container
 * @param window {object} window object
 * @param containerElement
 * @returns {boolean}
 */
function isOutsideOfContainerEdges(tooltipRefObj, window, containerElement) {
  var _a;
  var tooltipPosition = (_a = tooltipRefObj === null || tooltipRefObj === void 0 ? void 0 : tooltipRefObj.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
  var containerRect = getContainerDimensions(containerElement || window);
  return tooltipPosition.top < 0 || tooltipPosition.bottom > containerRect.height || tooltipPosition.left < 0 || tooltipPosition.right > containerRect.width;
}
/**
 * returns BoundingClientRect position like object,
 * if container ref is given this is calculated against it
 * otherwise browser window is used
 * @param target {RefObject}
 * @param container {RefObject}
 */
function getTargetBoundingClientRect(target, container) {
  if (container && target) {
    return {
      top: target.offsetTop - container.scrollTop,
      bottom: target.offsetTop + target.offsetHeight - container.scrollTop,
      left: target.offsetLeft,
      right: target.offsetLeft + target.offsetWidth,
      width: target.offsetWidth,
      height: target.offsetHeight,
      y: target.offsetTop - container.scrollTop,
      x: target.offsetLeft
    };
  }
  return target === null || target === void 0 ? void 0 : target.getBoundingClientRect();
}
/**
 * calculates the size of the zones on each side from the tooltip target element
 * returns zones with their sizes ordered from the biggest to the smallest
 * @param tooltipTargetPosition
 * @param containerRect
 * @param smartPositionOffset
 */
function calculateTooltipPositionZones(tooltipTargetPosition, containerRect, smartPositionOffset) {
  // tooltip target divides screen into 4 squares
  // checking which square is bigger,
  // meaning which direction from target has more space available
  var _a = smartPositionOffset.top,
    offsetTop = _a === void 0 ? 0 : _a,
    _b = smartPositionOffset.bottom,
    offsetBottom = _b === void 0 ? 0 : _b,
    _c = smartPositionOffset.left,
    offsetLeft = _c === void 0 ? 0 : _c,
    _d = smartPositionOffset.right,
    offsetRight = _d === void 0 ? 0 : _d;
  var tooltipZonesSizes = {
    // top direction square
    top: (tooltipTargetPosition.top - offsetTop) * containerRect.width,
    // bottom direction square
    bottom: (containerRect.height - tooltipTargetPosition.bottom - offsetBottom) * containerRect.width,
    // left direction square
    left: (tooltipTargetPosition.left + offsetLeft) * containerRect.height,
    // right direction square
    right: (containerRect.width - tooltipTargetPosition.right - offsetRight) * containerRect.height
  };
  var zonesSorted = Object.entries(tooltipZonesSizes).sort(function (a, b) {
    if (a[1] > b[1]) {
      return -1;
    }
    if (a[1] < b[1]) {
      return 1;
    }
    return 0;
  });
  return zonesSorted;
}

export { calculateTooltipPositionZones, getContainerDimensions, getTargetBoundingClientRect, isOutsideOfContainerEdges };
